import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { apiRequest, ajaxWatched } from "../../shared/services";
import { Link } from "react-router-dom";


function issueAuthRequest(emailTo, collectionId, ttlMinutes, preventEmail, callback) {
    let resource = '/v2/api/actions/issue-auth-token';

    return (dispatch, getState) => {
        dispatch(ajaxWatched(
            apiRequest(dispatch, getState, resource, {
                method: 'POST',
                body: JSON.stringify({
                    collectionId: collectionId,
                    emailedTo: emailTo,
                    ttlMinutes: ttlMinutes,
                    preventEmail: preventEmail
                })
            }).then(callback)
        ))
    }
}

function listCollections(callback) {
    let resource = '/v2/api/collections';

    return (dispatch, getState) => {
        dispatch(ajaxWatched(
            apiRequest(dispatch, getState, resource, {
                method: 'GET'
            })
        )).then(callback)
    }
}

const Selector = props => {
    if (props.items == null || props.items.length === 0){
        return <div>Loading...</div>
    }

    let opts = props.items.map((i, idx) => <option key={i[props.keyField]} value={i[props.keyField]}>{i[props.labelField]}</option>)

    opts.unshift(<option key="__blank__" value={null}></option>);
    return (
        <select name="collections" id="collections" defaultValue={props.defaultValue} onChange={props.onChange}>
            {opts}
        </select>
    )
}

const IssuedAuthRequest = props => {
    let val = props.value;

    return (
        <div>
            <h3>Request issued for <em>{val.collectionName}</em></h3>
            <label>Secret (for {val.emailTo}):</label>
            <p>{val.secret}</p>
            <label>Expires in ({val.ttlMinutes} minutes):</label>
            <p>{val.expiresAt.toLocaleString()}</p>
            <p><a href={val.collectionUrl}>Visit Collection</a></p>
            <p><a href={val.loginUrl}>Use it now (log in)</a></p>
            <hr />
        </div>
    );
}

const AuthRequests = function(props) {
    const [emailTo, setEmailTo] = useState(null);
    const [collectionId, setCollectionId] = useState(null);
    const [ttlMinutes, setTtlMinutes] = useState(60);
    const [preventEmail, setPreventEmail] = useState(true);
    const [collections, setCollections] = useState([]);
    const [issued, setIssued] = useState([]);

    const collectionsReceived = json => {
        setCollections(json);
    }

    useEffect(() => {
        props.dispatch(listCollections(collectionsReceived))
    }, [props]);

    const afterIssued = (emailTo, ttlMinutes) => json => {
        json['emailTo'] = emailTo;
        json['ttlMinutes'] = ttlMinutes;
        json['expiresAt'] = new Date(new Date().getTime() + ttlMinutes*60000);

        let val = [...issued];
        val.unshift(json);
        setIssued(val);
    }

    const handleSubmit = e => {
        e.preventDefault();
        props.dispatch(issueAuthRequest(emailTo, collectionId, ttlMinutes, preventEmail, afterIssued(emailTo, ttlMinutes)));
    }

    let issuedRequests = issued.map((i, idx) => <IssuedAuthRequest key={idx} value={i} />);

    return (
        <div className="ac-manager">
            <form onSubmit={handleSubmit}>
                <h2>Issue Auth Request</h2>
                <label htmlFor="collectionId">Collection ID:</label>
                <Selector keyField="id" labelField="name" items={collections} defaultValue={collectionId} onChange={e => { setCollectionId(e.target.value)}} />

                <label htmlFor="emailTo">Email To:</label>
                <input type="text" name="emailTo" id="emailTo" defaultValue={emailTo} onChange={e => setEmailTo(e.target.value)} />

                <label htmlFor="ttlMinutes">Expires in (Minutes):</label>
                <input type="text" name="ttlMinutes" id="ttlMinutes" defaultValue={ttlMinutes} onChange={e => setTtlMinutes(e.target.value)} />

                <label htmlFor="preventEmail">Prevent Email:</label>
                <input type="checkbox" name="preventEmail" id="preventEmail" defaultChecked={preventEmail} onChange={e => setPreventEmail(e.target.checked)} />

                <hr />
                <input type="submit" value="Submit" />
                <Link to="/app/manage/control-panel">Control Panel</Link>
            </form>
            <hr />
            <h2>Issued Auth Requests</h2>
            <>
                {issuedRequests}
            </>
        </div>
    );
}

function mapStateToProps(state) {
    return {}
}

export default connect(mapStateToProps)(AuthRequests);